import React, { useEffect, useRef } from "react";
import { RevenueChartModel } from "../../models/AdminDashboardModel";

type Props = {
    model?: RevenueChartModel
}

function RevenueChart(props: Props) {

    const ref = useRef<HTMLDivElement>(null);
    const chartRef = useRef<any>(null);

    useEffect(() => {
        if (!props.model || !ref.current) return;
        const Apex = (window as any).ApexCharts;
        const KTUtil = (window as any).KTUtil;
        if (!Apex || !KTUtil) return;

        const labelColor = KTUtil.getCssVariableValue("--bs-gray-500");
        const borderColor = KTUtil.getCssVariableValue("--bs-gray-200");
        const baseColor = KTUtil.getCssVariableValue("--bs-primary");
        const lightColor = KTUtil.getCssVariableValue("--bs-light-primary");

        const options = {
            series: [{ name: "Revenue", data: props.model.values }],
            chart: {
                fontFamily: "inherit",
                type: "area",
                height: 280,
                toolbar: { show: false }
            },
            legend: { show: false },
            dataLabels: { enabled: false },
            fill: { type: "solid", opacity: 0.25 },
            stroke: { curve: "smooth", width: 3, colors: [baseColor] },
            xaxis: {
                categories: props.model.labels,
                axisBorder: { show: false },
                axisTicks: { show: false },
                labels: { style: { colors: labelColor, fontSize: "12px" } }
            },
            yaxis: {
                labels: {
                    style: { colors: labelColor, fontSize: "12px" },
                    formatter: (v: number) => "$" + (v >= 1000 ? (v / 1000).toFixed(1) + "K" : v.toFixed(0))
                }
            },
            tooltip: {
                style: { fontSize: "12px" },
                y: { formatter: (v: number) => "$" + v.toLocaleString() }
            },
            colors: [lightColor],
            grid: { borderColor: borderColor, strokeDashArray: 4, yaxis: { lines: { show: true } } },
            markers: { strokeColor: baseColor, strokeWidth: 2 }
        };

        if (chartRef.current) {
            try { chartRef.current.destroy(); } catch { }
        }
        chartRef.current = new Apex(ref.current, options);
        chartRef.current.render();

        return () => {
            if (chartRef.current) {
                try { chartRef.current.destroy(); } catch { }
                chartRef.current = null;
            }
        };
    }, [props.model]);

    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header border-0 pt-5">
                <div>
                    <h3 className="widget-title">Revenue</h3>
                    <div className="widget-subtitle">Last 12 months · ${props.model?.total.toLocaleString() ?? 0} total</div>
                </div>
            </div>
            <div className="card-body pt-3">
                <div ref={ref} style={{ minHeight: 280 }} />
            </div>
        </div>
    );
}

export default RevenueChart;
